import axios from "axios";
import { apiAxiomLog } from "./logging";

export const apiLegislaideSearch = async (searchWords, cityCode) => {
  try {
    const searchFormatted = encodeURIComponent(searchWords);
    const config = {
      headers: {
        "X-API-KEY": `${process.env.NEXT_PUBLIC_LEGISLAIDE_KEY}`,
      },
    };
    const result = await axios
      .get(
        `https://backend.legislaide.com/agenda_item/public/search/${searchFormatted}?city_code=${cityCode}&limit=50`,
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          // RETURNS fileId
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    apiAxiomLog({
      stack: "frontEnd",
      function: "lib/api/legislaide apiLegislaideSearch",
      params: searchWords,
      error: error.toString(),
    });
    return null;
  }
};
